import React from 'react';
import { MessageCircle } from 'lucide-react';
import { siteConfig } from '../mock/data';
import { trackClick } from '../lib/tracking';
import { useSettings } from '../context/SettingsContext';

export default function WhatsAppFloat() {
  const { settings } = useSettings();
  const phone = settings.whatsapp_number || siteConfig.whatsappNumber;
  const waLink = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(siteConfig.waMessage)}`;

  return (
    <a
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackClick('whatsapp_floating')}
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Chat via WhatsApp"
    >
      <div className="relative pulse-ring w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-2xl flex items-center justify-center transition-colors">
        <MessageCircle className="w-7 h-7 text-white" fill="currentColor" strokeWidth={0} />
      </div>
      <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-white shadow-lg rounded-lg px-3 py-2 text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat WhatsApp
      </div>
    </a>
  );
}
